import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { ChartContainer } from '../../../../../../common/chart/chartContainer'
import Line from '../../../../../../common/chart/chartContainer/Line'
import { Element } from '../../../../../../common/html/element'
import { formatByTheme } from '../../../../../../helpers/theme'
import { valToPercent } from '../../../../../../helpers/value'
import CustomizedLabelLine from '../../../common/CustomizedLabelLine'
import { selectDataViewByTrend, selectIndicatorById } from '../store/slice'
import { RATIO_CODE } from './constant'

const Loss = ({ chart, isDynamicReport }) => {
  const dataByTrend = useSelector(selectDataViewByTrend)

  const isH50 = chart.includes(4) && chart.includes(5)

  return (
    <Element
      style={{ backgroundColor: !isDynamicReport ? '#F3F3F3' : undefined }}
      className={!isDynamicReport ? 'h100 px2 py2' : 'h100 py1'}
    >
      {chart.includes(4) && (
        <div className={isH50 ? 'h50 pb1 flexColumn' : 'h100 flexColumn'}>
          <div className="fw600 pb1">
            <Translate value="financialAnalysis.LOAN_LOSS_TO_NPL" />
          </div>
          <div className="flex1 minH0">
            <Chart
              data={dataByTrend}
              ratioCode={RATIO_CODE.LOAN_LOASS_TO_NPL}
              color="#006AA6"
            />
          </div>
        </div>
      )}
      {chart.includes(5) && (
        <div className={isH50 ? 'h50 pt1 flexColumn' : 'h100 flexColumn'}>
          <div className="fw600 pb1">
            <Translate value="financialAnalysis.LOAN_LOSS_TO_TOTAL_LOAN" />
          </div>
          <div className="flex1 minH0">
            <Chart
              data={dataByTrend}
              ratioCode={RATIO_CODE.LOAN_LOASS_TO_TOTAL_LOANS}
              color="#F49966"
            />
          </div>
        </div>
      )}
    </Element>
  )
}

const Chart = ({ data, ratioCode, color }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const indicatorById = useSelector(selectIndicatorById)

  return (
    <ChartContainer
      data={data}
      margin={{ top: 12, left: 0, bottom: 0, right: 0 }}
      width="100%"
      height="100%"
      cartesianGrid={{
        vertical: false,
        horizontal: true,
        stroke: formatByTheme('#D5D5D5'),
      }}
      xAxis={[
        {
          dataKey: 'year',
          padding: { left: 30, right: 30 },
          tickMargin: 3,
        },
      ]}
      yAxis={[
        {
          yAxisId: 'left',
          dataKeys: [ratioCode],
          isLineChart: true,
          hide: true,
        },
      ]}
      tooltip={{
        schema: {
          content: [
            {
              dataKey: ratioCode,
              label: indicatorById[ratioCode]?.ratioName,
              formatValue: (value) => valToPercent(value, locale),
            },
          ],
        },
      }}
    >
      <Line
        yAxisId={'left'}
        dataKey={ratioCode}
        stroke={color}
        strokeWidth={2}
        label={
          <CustomizedLabelLine
            formatValue={(val) => valToPercent(val, locale)}
          />
        }
      />
    </ChartContainer>
  )
}

export default Loss
